export const compulsaryTag = [
  "Introduction Competence",
  "Content Coverage",
  "Conclusion Competence",
  "Presentation & Structure",
  "Language Proficiency",
];
export const gradeMap = ["A+", "A", "B", "C", "D"];

export const studentRatingTags = [
  {
    name: "Introduction Competence",
  },
  {
    name: "Content Coverage",
  },
  {
    name: "Conclusion Competence",
  },
  {
    name: "Presentation & Structure",
  },
  {
    name: "Language Proficiency",
  },
];
export const initialState = {
  deadline: "", //done
  selectedEvaluator: "", //done
  selectedStatus: "", //done
  activePage: 1,
  currIndex: 0,
  reviewerComment: "", //done
  evaluatorGrade: "", //done
  showModelAnsPdf: { show: false, src: "" }, //done
  showEvaluatorPdf: { show: false, src: "" }, //done
  marksDropDown: false, //done
  ratingDropDown: false, //done
  existingDppData: JSON.parse(localStorage.getItem("dppInfoList")) || {}, //done
  apiType: "",
  apiRoute: "",
  isUpload: false,
  resData: null,
};

// This was breaking so added empty string
export const cloudFrontUrl = "";

export const AI_HYBRID_EVAL_TEST_TYPE = "AIHybridEvaluation";
